import { atom } from "recoil";

const navHeaderAtom = atom({

    key:"navHeader",
    default: 'Roll & Charge'

});

export default navHeaderAtom;